module.exports = __webpack_public_path__ + "static/Mini_Pies-f95754d95111c0610f44dac0f3e59b63.gif";